import { ApiHelper, IApiResponse } from "../../utils/api-helper";

const url = `${process.env.REACT_APP_API_ENDPOINT}/Sdgs`;
const reportUrl = `${process.env.REACT_APP_API_ENDPOINT}/Reports/SummarySdgs`;
const reportUrlSectorSdgs = `${process.env.REACT_APP_API_ENDPOINT}/Reports/SummarySectorSdgs`;
const reportUrlSummaryListOrganizationSdg = `${process.env.REACT_APP_API_ENDPOINT}/Reports/SummaryListOrganizationSdg`;
interface ILOVGroup {
    lovgroupcode: string;
}
class SDGsService extends ApiHelper {
    constructor(_url: string) {
        super(_url);
    }
    public GetProjectSDGByCode(projCode: string): Promise<IApiResponse | void> {
        try {
            this.url = `${url}/GetProjectSDGByCode`;
            return super.getById(projCode);
        } catch (e) {
            throw e;
        }
    }
    
    public updateProjectByIframe(projectId: number, body: any, accessToken?: string | null): Promise<IApiResponse | void> {
        try {
            if (accessToken) {
                // ใช้ fetch โดยตรงเฉพาะกรณีที่มี accessToken จาก URL
                return this.updateWithFetch(`${url}/UpdateProject/${projectId}`, body, accessToken);
            }
            
            // ใช้วิธีเดิมเมื่อไม่มี accessToken (จะใช้ auth ที่มีอยู่ในระบบ)
            this.url = `${url}/UpdateProject`;
            return super.update(body, projectId);
        } catch (e) {
            throw e;
        }
    }

    public updateMinimumProjectByIframe(projectId: number, body: any, accessToken?: string | null): Promise<IApiResponse | void> {
        try {
            if (accessToken) {
                // ใช้ fetch โดยตรงเฉพาะกรณีที่มี accessToken จาก URL
                return this.updateWithFetch(`${url}/Minimum/${projectId}`, body, accessToken);
            }
            
            // ใช้วิธีเดิมเมื่อไม่มี accessToken
            this.url = `${url}/Minimum`;
            const result = super.update(body, projectId);
            this.url = url; // คืนค่า url เดิม
            return result;
        } catch (e) {
            throw e;
        } finally {
            this.url = url;
        }
    }

    // Helper method สำหรับใช้ fetch พร้อม custom token
    private async updateWithFetch(apiUrl: string, body: any, accessToken: string): Promise<IApiResponse | void> {
        try {
            const response = await fetch(apiUrl, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify(body)
            });
            
            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
            }
            
            const result = await response.json();
            
            // แปลง response ให้เป็น format เดียวกับ ApiHelper
            return {
                success: response.ok ? "true" : "false",
                data: result,
                error: [],
                headers: {}
            } as IApiResponse;
            
        } catch (error) {
            console.error('API Error:', error);
            throw error;
        }
    }
    public UpdateProjectSDG( body: any): Promise<IApiResponse | void> {
        try {
            this.url = `${url}/UpdateProjectSDG`;
            return super.create(body);
        } catch (e) {
            throw e;
        } finally {
           
        }
    }
    public getByCodeByIframe(projCode: string): Promise<IApiResponse | void> {
        try {
            this.url = url;
               this.url = `${url}/ByCodeByIframe`;
               return super.getById(projCode);
           } catch (e) {
               throw e;
           }
    }
      public async GetLOVByGroupByIframe(queries: ILOVGroup): Promise<IApiResponse | void> {
            try {
                this.url = url;
                const result = await super.get(queries, { name: "GetLOVByGroupByIframe" });
                return result;
            } catch (e) {
                throw e;
            }
        }
            public getCurrencyByIframe(year: number): Promise<IApiResponse | void> {
                try {
                    this.url = url;
                    this.url = `${url}/CurrencyDataByIframe`;
                    return super.get({ year });
                } catch (e) {
                    throw e;
                }
                finally {
                    this.url = url;
                }
            }
    public GetSummarySdg(body: any): Promise<IApiResponse | void> {
        try {
            this.url = url;
            return super.create(body, { name: "GetSummarySdg" });
        } catch (e) {
            throw e;
        }
    }
    public GetSummaryListSdg(body: any): Promise<IApiResponse | void> {
        try {
            this.url = url;
            return super.create(body, { name: "GetSummaryListSdg" });
        } catch (e) {
            throw e;
        }
    }
    public GetSummaryListSectorSdg(body: any): Promise<IApiResponse | void> {
        try {
            this.url = url;
            return super.create(body, { name: "GetSummaryListSectorSdg" });
        } catch (e) {
            throw e;
        }
    }
    public GetSummaryListOrganizationSdg(body: any): Promise<IApiResponse | void> {
        try {
            this.url = url;
            return super.create(body, { name: "GetSummaryListOrganizationSdg" });
        } catch (e) {
            throw e;
        }
    }
    public GetSummaryListProjectSdg(body: any): Promise<IApiResponse | void> {
        try {
            this.url = url;
            return super.create(body, { name: "GetSummaryListProjectSdg" });
        } catch (e) {
            throw e;
        }
    }
     public printSummarySdgs(body: any): Promise<IApiResponse | void> {
      this.url = reportUrl;
       try {
         return super.createFileByBody(body);
       } catch (e) {
         throw e;
       }
     }
     public printSummarySectorSdgs(body: any): Promise<IApiResponse | void> {
        this.url = reportUrlSectorSdgs;
         try {
           return super.createFileByBody(body);
         } catch (e) {
           throw e;
         }
       }
       public printSummaryListOrganizationSdg(body: any): Promise<IApiResponse | void> {
        this.url = reportUrlSummaryListOrganizationSdg
         try {
           return super.createFileByBody(body);
         } catch (e) {
           throw e;
         }
       }

}
const SDGsAPI = new SDGsService(url);
export default SDGsAPI;
